import React, { useEffect, useState } from 'react';
import { StateView } from '../../common/StateView';
import { useGetMap } from './useGetMap';
import { GoogleMap, MarkerF, useJsApiLoader } from '@react-google-maps/api';
import {
  devOrProd,
  GOOGLE_MAPS_DEV_API_KEY,
  GOOGLE_MAPS_PROD_API_KEY,
} from '../../../util/env';
import { Spinner } from '@chakra-ui/react';
import { type Marker } from '../../../util/types';
import { useUpdateMarkers } from './useUpdateMarkers';

const center = {
  lat: 3.745,
  lng: 38.523,
};
const containerStyle = {
  width: 'auto',
  height: '700px',
};

const DEFAULT_ZOOM = 2;

export const Map: React.FC = StateView(useGetMap, (data) => {
  const [, setMap] = React.useState<google.maps.Map>();
  const [markers, setMarkers] = useState<Marker[]>(data.markers);
  const { updateMarkers } = useUpdateMarkers(markers);
  const onLoad = React.useCallback(function callback(map: google.maps.Map) {
    setMap(map);
  }, []);
  const { isLoaded } = useJsApiLoader({
    id: 'google-map-unesco',
    googleMapsApiKey: devOrProd(
      GOOGLE_MAPS_DEV_API_KEY,
      GOOGLE_MAPS_PROD_API_KEY,
    ),
  });

  useEffect(() => {
    updateMarkers();
  }, [markers]);

  const handleAdd = ({ latLng }: google.maps.MapMouseEvent): void => {
    setMarkers((prevState) => [
      ...prevState,
      { latitude: latLng!.lat()!, longitude: latLng!.lng() },
    ]);
  };

  return isLoaded ? (
    <>
      <GoogleMap
        center={center}
        mapContainerStyle={containerStyle}
        zoom={DEFAULT_ZOOM}
        onLoad={onLoad}
        onClick={handleAdd}
      >
        {markers.map((marker: Marker, index: number) => {
          return (
            <MarkerF
              options={{
                icon: {
                  path: google.maps.SymbolPath.CIRCLE,
                  scale: 3,
                },
              }}
              key={index}
              position={{ lat: marker.latitude, lng: marker.longitude }}
            />
          );
        })}
      </GoogleMap>
    </>
  ) : (
    <Spinner />
  );
});
